import React, { useEffect, useState } from 'react';
import Journal from '../data/publication/journal.json';
import InterConf from '../data/publication/reviewed_inter_conf.json';
import InterPoster from '../data/publication/inter_demo_poster.json';
import Invited from '../data/publication/invited.json';
import DomesticConfR from '../data/publication/reviewed_conf.json';
import DomesticConf from '../data/publication/conf.json';
import Commentary from '../data/publication/commentary.json';
import Award from '../data/publication/award.json';
import { langData } from "../libs/Utils";


export const Publication = (props) => {
  const { lang, ua } = props;
  const journal = langData(lang, Journal);
  const interConf = langData(lang, InterConf);
  const interPoster = langData(lang, InterPoster);
  const invited = langData(lang, Invited);
  const domesticConfR = langData(lang, DomesticConfR);
  const domesticConf = langData(lang, DomesticConf);
  const commentary = langData(lang, Commentary);
  const award = langData(lang, Award);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(true);
  }, [])

  const createAuthors = (authors, key) => {
    const al = authors.length;
    return (
      <span>
        {authors.map((a, i) => {
          let comma = (i < al - 1) ? ((i === al - 2 && lang === "ja") ? ", and " : ", ") : "";
          return (
            <span key={key + '_' + i}>
              <span className={(a === "Yuki Ban" || a === "伴祐樹") ? 'me' : 'author'}>{a}</span>
              {comma}
            </span>
          );
        })}
      </span>)
  }

  const createPubLine = (data, key, num) => {
    return (
      <li key={key} className="publine">
        <div className="num">{num + "."}</div>
        <div>
          {createAuthors(data.authors, key)}
          <span>{". "}</span>
          <span>{data.when}</span>
          <span>{". "}</span>
          <strong>{data.title}</strong>
          <span>{". "}</span>
          <span>{(data.where === "" ? [data.publish, data.vol] : [data.publish, data.vol, data.where]).join(", ")}</span>
          <span className="award" style={{ display: (data.award === "" ? "none" : "inline-block") }}>{data.award}</span>
          {data.link === undefined ? <a className={"doi " + (data.doi === "" ? "hidden-div" : "")} href={data.doi}>{"[doi]"}</a> :
            <a className={"doi " + (data.link === "" ? "hidden-div" : "")} href={data.link}>{"[link]"}</a>}

        </div>
      </li>
    );
  }

  const monthList = ["Jan.", "Feb.", "Mar.", "Arp.", "May", "Jun.", "Jul.", "Aug.", "Sep.", "Oct.", "Nov.", "Dec."];

  const createSimpleLine = (data, key, num) => {
    return (
      <li key={key} className="publine">
        <div className="num">{num + "."}</div>
        <div>
          <strong>{lang === "jp" ? data.title_jp : data.title_en}</strong>
          <span>{", "}</span>
          <span>{lang === "jp" ? data.year + "年" + data.month + "月" : monthList[parseInt(data.month) - 1] + " " + data.year}</span>
        </div>
      </li>
    );
  }

  const pubsClass = (ua === "pc" ? "pubs content-offset" : "pubs");

  return (
    <div id="publication" className={"page-wrapper " + (loaded ? "opacity-one" : "opacity-zero")}>
      <div className="title">JOURNAL PAPERS</div>
      <ul className={pubsClass}>
        {journal.map((d, i) =>
          createPubLine(d, "j_" + i, i + 1)
        )}
      </ul>
      <div className="title">CONFERENCE PAPERS (Peer-Reviewed)</div>
      <ul className={pubsClass}>
        {interConf.map((d, i) =>
          createPubLine(d, "ic_" + i, i + 1)
        )}
      </ul>
      <div className="title">POSTER / DEMO PAPERS (Peer-Reviewed)</div>
      <ul className={pubsClass}>
        {interPoster.map((d, i) =>
          createPubLine(d, "ip_" + i, i + 1)
        )}
      </ul>
      <div className="title">INVITED CONFERENCE PAPERS</div>
      <ul className={pubsClass}>
        {invited.map((d, i) =>
          createPubLine(d, "in_" + i, i + 1)
        )}
      </ul>
      <div>
        <div className={"title" + (domesticConfR.length === 0 ? " hidden-div" : "")}>DOMESTIC CONFERENCE PAPERS (Peer-Reviewed)</div>
        <ul className={pubsClass}>
          {domesticConfR.map((d, i) =>
            createPubLine(d, "dcr_" + i, i + 1)
          )}
        </ul>
      </div>
      <div>
        <div className={"title" + (domesticConf.length === 0 ? " hidden-div" : "")}>DOMESTIC CONFERENCE PAPERS</div>
        <ul className={pubsClass}>
          {domesticConf.map((d, i) =>
            createPubLine(d, "dc_" + i, i + 1)
          )}
        </ul>
      </div>
      <div>
        <div className={"title" + (commentary.length === 0 ? " hidden-div" : "")}>COMMENTARY</div>
        <ul className={pubsClass}>
          {commentary.map((d, i) =>
            createPubLine(d, "cm_" + i, i + 1)
          )}
        </ul>
      </div>
      <div>
        <div className={"title" + (award.length === 0 ? " hidden-div" : "")}>AWARDS / HONORS</div>
        <ul className={pubsClass}>
          {award.map((d, i) =>
            createSimpleLine(d, "aw_" + i, i + 1)
          )}
        </ul>
      </div>
    </div>
  );
};
